import inclusiveRandom from 'lodash/random';

export function promoteGamesInList(games, offset = 30) {
  const GAMES_TO_PROMOTE = 2;
  if (!games || games.length <= offset + GAMES_TO_PROMOTE) {
    return games;
  }
  const result = [...games];
  for (let i = 0; i < GAMES_TO_PROMOTE; ++i) {
    const pick = inclusiveRandom(offset, result.length - i - 1);
    const game = result.splice(pick, 1)[0];
    result.push(game);
  }
  return result;
}
